/* ----------
    Lib
-----------*/

function checkUrlPdf(url) {
    let urlExploded = url.split('.')
    if (urlExploded[urlExploded.length - 1].toLowerCase() == 'pdf') {
        return true
    }
    return false
}

function iterate(pdf, callback) {
    var canvas = document.createElement('canvas'), // single off-screen canvas
        ctx = canvas.getContext('2d'),             // to render to
        pages = [],
        currentPage = 1

    // when promise is returned do as usual
    pdf.getPage(currentPage).then(function(page) {

        var scale = 1.5;
        var viewport = page.getViewport(scale);

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
            canvasContext: ctx,
            viewport: viewport
        };

        // now, tap into the returned promise from render:
        page.render(renderContext).then(function() {

            // store compressed image data in array
            pages.push(canvas.toDataURL());

            if (currentPage < pdf.numPages) {
                currentPage++;
                getPage();        // get next page
            }
            else {
                callback(canvas.toDataURL())
            }
        });
    });
}


/* --------------
    FUNCTIONS
---------------*/

function convertPdfToBlob(fileUrl, callback, toBlob = true) {
    // Convert to image data
    let callbackToImageData = async (b64Img) => {
        if (toBlob) {
            const dataToBlob = async (imageData) => {
                return await (await fetch(imageData)).blob();
            };
            const blobImg = await dataToBlob(b64Img);
            callback(blobImg)
        } else {
            callback(b64Img)
        }
    }
    if (checkUrlPdf(fileUrl)) {
        PDFJS.getDocument(fileUrl).then((pdf) => {
            // Transform to pdf
            return iterate(pdf, callbackToImageData)
        });
    }
}

function convertBlobToPdf(imgB64) {
    var doc = new jsPDF("p", "mm", "a4")
    var width = doc.internal.pageSize.getWidth()
    var height = doc.internal.pageSize.getHeight()

    doc.addImage(imgB64, 'PNG', 0, 0, width, height)

    // Convert to blob
    var blobPdf =  doc.output('blob')
    return blobPdf
}

var PdfTool = {
    convertPdfToBlob,
    convertBlobToPdf
}

export default PdfTool



// WEBPACK FOOTER //
// ./src/tools/PdfTool.js